import { Filter, Form } from '@/components'
import React from 'react'

function AdoptionFairMessagesFilter() {
  return (
    <Filter
      initialValues={{
        animalName_cont: '',
        fairTitle_cont: '',
        onlyUnread: false,
      }}
      title="Filtrar mensagens"
      renderForm={() => (
        <>
          <Form.Group>
            <Form.Switch className="form-switch" key="onlyUnread" style={{ marginTop: 15 }}>
              <Form.ValidationField
                type="checkbox"
                name="onlyUnread"
                id="onlyUnread"
              />
              <i className="form-icon" />
              &nbsp;Mostrar apenas não lidas
            </Form.Switch>
          </Form.Group>
          <div className="divider text-center" data-content="Pet" />
          <Form.Group>
            <Form.Label className="text-sm" htmlFor="animalName_cont">Nome do pet</Form.Label>
            <Form.ValidationField
              name="animalName_cont"
              className="input-sm"
              autoFocus
              id="animalName_cont"
              autoComplete="none"
              placeholder="Totó da Silva"
            />
          </Form.Group>
          <div className="divider text-center" data-content="Feira" />
          <Form.Group>
            <Form.Label className="text-sm" htmlFor="fairTitle_cont">Título da feira</Form.Label>
            <Form.ValidationField
              name="fairTitle_cont"
              className="input-sm"
              id="fairTitle_cont"
              autoComplete="none"
              placeholder="Feira 1"
            />
          </Form.Group>
        </>
      )}
    />
  )
}

export default AdoptionFairMessagesFilter
